export const cdnImageWrap = (url, width = 160, height = 160, fit = "cover") =>
  `https://nobul.com/cdn-cgi/image/width=${width},height=${height},fit=${fit},quality=85,format=auto/${url}`;
